import React from 'react'
import "./Startup.css"
const Startup = () => {
  return (
    <div>
      Startup
    </div>
  )
}

export default Startup
